import { cn } from "@/lib/utils";
import type { ChangeEvent } from "react";

interface CodeInputProps {
  value: string;
  onChange: (code: string) => void;
  disabled?: boolean;
  error?: boolean;
}

export function CodeInput({ value, onChange, disabled, error }: CodeInputProps) {
  function handleChange(e: ChangeEvent<HTMLInputElement>) {
    const raw = e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 5);
    onChange(raw);
  }

  return (
    <input
      type="text"
      inputMode="text"
      maxLength={5}
      value={value}
      disabled={disabled}
      placeholder="XXXXX"
      autoFocus
      onChange={handleChange}
      className={cn(
        "w-full rounded-xl border-2 px-4 py-4 text-center font-mono text-3xl font-bold uppercase tracking-[0.5em]",
        "focus:border-brand-coral focus:outline-none focus:ring-2 focus:ring-brand-coral/20",
        "dark:bg-[#333] dark:text-white",
        error
          ? "border-red-500 dark:border-red-400"
          : "border-black dark:border-white/30",
        disabled && "opacity-50",
      )}
    />
  );
}
